import {NavLink} from "react-router-dom";
import {WorkloadConfig, TabHideIf} from "modules/integrations/validator.ts";
import navDataTest from "testUtils/navDataTest";
import {ServiceNav} from "ui-utils/ServiceNav.tsx";
import {endsWith} from "lodash";
import {useSelector} from "react-redux";
import {RootState} from "store";
import {useIsGovAccount} from "utils/useIsGovAccount.ts";

const NewServiceNav = ({serviceConfig}: {serviceConfig: WorkloadConfig[]}) => {
    const activeFeatures = useSelector((state: RootState) => state.features.active);
    
    const isDemoAccount = useSelector((state: RootState) => state.tenancy.isDemo);
    const isGovAccount = useIsGovAccount();

    // usage example in workload-config.json, inside a tab object:
    // "hideIf": ["isGovAccount", "isDemoAccount"]
    const stateFields: Record<TabHideIf, boolean> = {
        isGovAccount,
        isDemoAccount,
    };
    return <ServiceNav label={serviceConfig?.serviceNav?.label}>
        {serviceConfig?.serviceNav?.tabs
            ?.filter(tab => !tab.featureId || activeFeatures[tab.featureId])
            ?.filter(tab => !tab.hideIf || tab.hideIf.every((field: TabHideIf) => !stateFields[field]))
            ?.map(tab => {
            return <NavLink to={
                serviceConfig.to && serviceConfig.to !== "/" && !tab.to.startsWith(serviceConfig.to) && !tab.to.startsWith(`${serviceConfig.to}`)
                    ? (endsWith(serviceConfig.to, "/") ? `${serviceConfig.to}${tab.to}` : `${serviceConfig.to}/${tab.to}`)
                    : tab.to
            } key={tab.to} data-testid={`${navDataTest.serviceNavItem}${tab.label}`}>
                {tab.label}
            </NavLink>
        })}
    </ServiceNav>
}

export default NewServiceNav;